<div class="chat-bot-container">
    <app-poi-sidebar></app-poi-sidebar>
    @if (dataChat.configLoaded()) {
        <chat-view></chat-view>
    }
</div>